function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MobileContextMenu from '../MobileContextMenu';
import windowIsBelowSize from '../utils/window-is-below-size';
import { getMenuData, getArrowData } from '../utils/popover-menu-origin-calculator';
import { getClassName } from '../utils/get-class-name';
import { MenuContainer, ArrowFill, ArrowBorder, PopoverMenu } from '../PopoverButton/PopoverButton';
import TscThemeName from '../constants/TscThemeName';
import tscStyles from '../constants/TscStyles';
import TscPopoverOrigin from '../constants/TscPopoverOrigin';
var defaultProps = {
  closeMenuOnClick: false,
  maxHeight: '15rem',
  maxWidth: '15rem',
  mobileZindex: 1,
  origin: TscPopoverOrigin.bottom,
  showArrow: false,
  showMenu: true,
  themeName: TscThemeName.dawn,
  useMobileMenu: true
};

var ContextMenu = function ContextMenu(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      children = _defaultProps$props.children,
      className = _defaultProps$props.className,
      closeMenuOnClick = _defaultProps$props.closeMenuOnClick,
      maxHeight = _defaultProps$props.maxHeight,
      maxWidth = _defaultProps$props.maxWidth,
      mobileMenuTitle = _defaultProps$props.mobileMenuTitle,
      mobileZindex = _defaultProps$props.mobileZindex,
      onClose = _defaultProps$props.onClose,
      origin = _defaultProps$props.origin,
      showArrow = _defaultProps$props.showArrow,
      showMenu = _defaultProps$props.showMenu,
      themeName = _defaultProps$props.themeName,
      useMobileMenu = _defaultProps$props.useMobileMenu; // overlay the defaultProps and passed in props in logical order and spread to constant values


  var isMobileMenu = useMobileMenu && windowIsBelowSize(tscStyles.breakpoints.contextMenuBreakpoint);
  var menuElement;

  if (isMobileMenu) {
    menuElement = _jsx(MobileContextMenu, {
      className: className,
      visible: showMenu,
      onClose: onClose,
      zIndex: mobileZindex,
      themeName: themeName,
      title: mobileMenuTitle,
      children: _jsx(PopoverMenu, {
        className: getClassName(className, 'popover-menu'),
        maxHeight: maxHeight,
        themeName: themeName,
        children: children
      })
    });
  } else {
    menuElement = _jsxs(MenuContainer, {
      className: getClassName(className, null, 'menu-container'),
      visible: showMenu,
      data: getMenuData(origin, showArrow),
      children: [showArrow && _jsx(ArrowBorder, {
        className: getClassName(className, 'arrow-border'),
        data: getArrowData(origin)
      }), showArrow && _jsx(ArrowFill, {
        className: getClassName(className, 'arrow-fill'),
        data: getArrowData(origin)
      }), _jsx(PopoverMenu, {
        className: getClassName(className, 'popover-menu'),
        onClick: function onClick(e) {
          return closeMenuOnClick && onClose && onClose(e);
        },
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        themeName: TscThemeName.dawn,
        children: children
      })]
    });
  }

  return menuElement;
};

ContextMenu.defaultProps = defaultProps;
/** @component */

export default ContextMenu;